import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoadingService } from './services/loading.service';
import { finalize, Observable } from 'rxjs';

@Injectable()
export class httpInterceptorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const loadingService = inject(LoadingService);
    loadingService.show();
    return next.handle(req).pipe(
      finalize(() => loadingService.hide())
    );
  }
}
